import type { PropsWithChildren } from 'react';
import { tv } from 'tailwind-variants';

const style = tv({
  base: 'text-sm text-gray-500',
  variants: { error: { true: 'text-red-600' } },
});

export type HintProps = PropsWithChildren<{
  error?: boolean;
  className?: string;
}>;

export function Hint({ children, className, error = false }: HintProps) {
  return <div className={style({ className, error })}>{children}</div>;
}
